import React from 'react'

export const InOfferFlowContext = React.createContext<boolean>(false)
